import * as React from 'react';

export interface DropdownComponentProps {
  content?: React.ReactNode;
  visible: boolean;
  className?: string;
  children?: React.ReactNode;
  onShow?: (visible: boolean) => any;
}

export function DropdownComponent({
  content,
  visible,
  className,
  children,
  onShow,
}: DropdownComponentProps): JSX.Element {
  return (
    <div
      onClick={() => onShow?.(!visible)}
      style={{
        position: 'relative',
        display: 'inline-block',
        width: '100%',
        cursor: 'pointer',
      }}
      className={className ?? ''}
    >
      {children}
      {visible && content && (
        <div
          style={{
            position: 'absolute',
            right: 22,
            zIndex: 10001,
            top: 36,
          }}
        >
          {content}
        </div>
      )}
    </div>
  );
}
